import { APP_TOKEN_KEY, APP_USER_KEY, exchangeForAppToken } from "../Services/authService";

let sessionRecoveryPromise = null;

async function recoverAppSession() {
  if (!navigator.onLine) return null;

  if (!sessionRecoveryPromise) {
    sessionRecoveryPromise = exchangeForAppToken()
      .catch(() => null)
      .finally(() => {
        sessionRecoveryPromise = null;
      });
  }

  return sessionRecoveryPromise;
}

function clearAuthAndRedirectToLogin() {
  localStorage.removeItem(APP_TOKEN_KEY);
  localStorage.removeItem(APP_USER_KEY);
  if (window.location.pathname !== "/") {
    window.location.href = "/";
  }
}

// --- core fetch wrapper ---
export async function apiFetch(token, url, options = {}, allowSessionRecovery = true) {
  try {
    const res = await fetch(url, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...(options.headers || {}),
      },
    });

    if (res.status === 401 || res.status === 403) {
      if (allowSessionRecovery) {
        const refreshedToken = await recoverAppSession();
        if (refreshedToken) {
          return apiFetch(refreshedToken, url, options, false);
        }
      }

      console.warn("Auth failed after session recovery attempt, redirecting to login…");
      clearAuthAndRedirectToLogin();
      throw new Error("Unauthorized");
    }

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`API error ${res.status}: ${text}`);
    }
    return res.json();
  } catch (err) {
    console.error("API call failed:", err);
    throw err;
  }
}


export async function apiFetchNoRedirect(token, url, options = {}) {
  try {
    const res = await fetch(url, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...(options.headers || {}),
      },
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`API error ${res.status}: ${text}`);
    }
    return res.json();
  } catch (err) {
    console.error("API call failed:", err);
    throw err;
  }
}
